module.exports = __webpack_public_path__ + "09_long_brown.0a4e789c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer5/09_long_brown.png
// module id = 1ziL
// module chunks = 0